export default __webpack_public_path__ + "static/media/topping_lollipop.165dbba1.jpg";